import axios from "axios";
import { API_BASE_URL } from "../apiClient";

const SIMPLE_FARM_BASE = `${API_BASE_URL}/api/public/simple-farm`;

function authHeaders() {
  const token = localStorage.getItem("authToken");
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "Content-Type": "application/json",
  };
}

function client() {
  return axios.create({ baseURL: SIMPLE_FARM_BASE, headers: authHeaders() });
}

function cleanPayload(payload = {}) {
  const out = {};
  Object.entries(payload).forEach(([key, value]) => {
    if (value === "" || value === undefined) return;
    out[key] = value;
  });
  return out;
}

function apiMsg(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    (typeof error?.response?.data === "string" ? error.response.data : null) ||
    error?.message ||
    "Request failed"
  );
}

const simpleFarmService = {
  _apiMsg: apiMsg,

  stocks: {
    list: async () => (await client().get("/stocks")).data || [],
    lowStock: async () => (await client().get("/stocks/low-stock")).data || [],
    create: async (payload) => (await client().post("/stocks", cleanPayload(payload))).data,
    update: async (id, payload) => (await client().put(`/stocks/${id}`, cleanPayload(payload))).data,
    restock: async (id, payload) => (await client().post(`/stocks/${id}/restock`, cleanPayload(payload))).data,
    restockHistory: async (stockId) => (await client().get("/stocks/restock-history", { params: stockId ? { stockId } : {} })).data || [],
    restockHistoryForStock: async (id) => (await client().get(`/stocks/${id}/restock-history`)).data || [],
    remove: async (id) => client().delete(`/stocks/${id}`),
  },

  fertilizers: {
    list: async () => (await client().get("/fertilizers")).data || [],
    create: async (payload) => (await client().post("/fertilizers", cleanPayload(payload))).data,
    update: async (id, payload) => (await client().put(`/fertilizers/${id}`, cleanPayload(payload))).data,
    remove: async (id) => client().delete(`/fertilizers/${id}`),
  },

  zones: {
    list: async () => (await client().get("/zones")).data || [],
    create: async (payload) => (await client().post("/zones", cleanPayload(payload))).data,
    update: async (id, payload) => (await client().put(`/zones/${id}`, cleanPayload(payload))).data,
    remove: async (id) => client().delete(`/zones/${id}`),
    listValves: async (zoneId) => (await client().get(`/zones/${zoneId}/valves`)).data || [],
    createValve: async (zoneId, payload) => (await client().post(`/zones/${zoneId}/valves`, cleanPayload(payload))).data,
    updateValve: async (valveId, payload) => (await client().put(`/zones/valves/${valveId}`, cleanPayload(payload))).data,
    removeValve: async (valveId) => client().delete(`/zones/valves/${valveId}`),
  },

  schedules: {
    list: async () => (await client().get("/schedules")).data || [],
    create: async (payload) => (await client().post("/schedules", cleanPayload(payload))).data,
    update: async (id, payload) => (await client().put(`/schedules/${id}`, cleanPayload(payload))).data,
    remove: async (id) => client().delete(`/schedules/${id}`),
  },

  todayWorks: {
    list: async (date) => (await client().get("/today-works", { params: date ? { date } : {} })).data || [],
    generate: async (date) => (await client().post("/today-works/generate", null, { params: date ? { date } : {} })).data || [],
    complete: async (workId, remarks = "") => (await client().post(`/today-works/${workId}/complete`, { remarks })).data,
    skip: async (workId, remarks = "") => (await client().post(`/today-works/${workId}/skip`, { remarks })).data,
  },
};

export default simpleFarmService;
